module.exports = __webpack_public_path__ + "static/media/book_a150.b399429b.jpg";